import LoadingButton from "@mui/lab/LoadingButton";
import { 
    Typography, Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, 
    TextField, List, ListItem, ListItemAvatar, ListItemText, 
    Avatar, InputAdornment, DialogActions, FormControlLabel, Divider,
    Container
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { requestOptions } from "../../../../../../Helpers/function";
import api from '../../../../../../Apis'
import {
    Link
} from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next'
import SearchIcon from '@mui/icons-material/Search';
import { useCookies } from "react-cookie";

export default function SplitGroupFanpage(props) {
    const [cookies] = useCookies('is_login');
    const { t, i18n } = useTranslation();
    const [state, setState] = useState({
        dialog: false,
        dialogSelectPage: false,
        loading_submit: false,
        fanpage_selected: [],
        dialogKey: 0, // Thêm key để force re-render DialogSelectFanpages
        searchTerm: "",
        data_api: null,
        last_page: 1,
        group_pages: []
    })

    const { register, handleSubmit, reset } = useForm();

    // Lấy danh sách fanpage chưa có nhóm
    const availableFanpages = useMemo(() => {
        return state.data_api?.fanpages?.filter(fanpage => fanpage.fanpage_groups_count == 0) || [];
    }, [state.data_api?.fanpages]);
    

    // Lọc danh sách theo từ khóa search
    const filteredFanpages = useMemo(() => {
        return availableFanpages.filter(item => 
            item.name.toLowerCase().includes(state.searchTerm.toLowerCase()) || 
            item.fanpage_id.toString().includes(state.searchTerm)
        );
    }, [availableFanpages, state.searchTerm]);

    // Xử lý chọn/bỏ chọn từng fanpage
    const handleTogglePage = (fanpage) => {
        const currentIndex = state.fanpage_selected.findIndex(item => item.fanpage_id === fanpage.fanpage_id);
        const newSelected = [...state.fanpage_selected];

        if (currentIndex === -1) {
            newSelected.push(fanpage);
        } else {
            newSelected.splice(currentIndex, 1);
        }
        setState({ ...state, fanpage_selected: newSelected });
    };

    // Xử lý Chọn tất cả (Dựa trên danh sách đang hiển thị sau khi lọc)
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            // Hợp nhất danh sách hiện tại vào danh sách đã chọn (tránh trùng lặp)
            const newSelected = [...state.fanpage_selected];
            filteredFanpages.forEach(page => {
                if (!newSelected.some(item => item.fanpage_id === page.fanpage_id)) {
                    newSelected.push(page);
                }
            });
            setState({ ...state, fanpage_selected: newSelected });
        } else {
            // Loại bỏ các page đang hiển thị khỏi danh sách đã chọn
            const filteredIds = filteredFanpages.map(p => p.fanpage_id);
            const newSelected = state.fanpage_selected.filter(item => !filteredIds.includes(item.fanpage_id));
            setState({ ...state, fanpage_selected: newSelected });
        }
    };

    // Kiểm tra xem đã chọn tất cả các page đang hiển thị chưa
    const isAllSelected = filteredFanpages.length > 0 && filteredFanpages.every(page => 
        state.fanpage_selected.some(selected => selected.fanpage_id === page.fanpage_id)
    );

    const splitFanpage = (data) => {
        if (state.fanpage_selected.length === 0) {
            Swal.fire(t("Vui lòng chọn ít nhất 1 fanpage"), "", "warning");
            return;
        }
        data["fanpage_selected"] = state.fanpage_selected;
        data["lang"] = i18n.language;
        setState({ ...state, loading_submit: true });

        fetch(api.split_fanpage, requestOptions('POST', cookies.is_login, data))
            .then(res => res.json())
            .then((result) => {
                if (result.success) {
                    Swal.fire({ title: result.message, timer: 2000, icon: 'success' });
                    updateGroupPage(result.group_pages);
                    setState((prev) => ({
                        ...prev,
                        loading_submit: false,
                        dialog: false,
                        fanpage_selected: [], // Reset danh sách fanpage đã chọn
                        dialogKey: state.dialogKey + 1 // Tăng key để force re-render DialogSelectFanpages
                    }))
                    reset({
                        group_name: ""
                    });
                } else {
                    Swal.fire({ title: result.message, timer: 2000, icon: 'warning' });
                    setState((prev) => ({
                        ...prev,
                        loading_submit: false
                    }));
                }
            });
    }

    const onCheckedFanpage = (newValue) => {
        setState({
            ...state,
            fanpage_selected: newValue
        })
    }    

    
    const reloadData = () => {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookies.is_login
                },
                body: JSON.stringify({
                    // fanpage_id: id,
                    page: state.page,
                    lang: i18n.language
                })
            };
            fetch(api.get_post, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.success) {
                        setState((prev) => ({
                            ...prev,
                            data_api: result.datas,
                            last_page: result.last_page,
                            group_pages: result.group_pages
                        }))
                    }
                }
            )
        }
    
        const updateGroupPage = (data) => {
            const old_group_pages = [...state.group_pages];
            const new_group_pages = old_group_pages.concat(data);
            
            // Cập nhật group_name cho các fanpage đã được phân nhóm
            const updated_fanpages = state.data_api.fanpages.map(fanpage => {
                // Tìm fanpage trong các nhóm mới được tạo
                const foundInNewGroup = data.find(group => 
                    group.fanpages && Array.isArray(group.fanpages) && 
                    group.fanpages.some(fp => fp.fanpage_id === fanpage.fanpage_id)
                );
                
                if (foundInNewGroup) {
                    return {
                        ...fanpage,
                        group_name: foundInNewGroup.group_name
                    };
                }
                return fanpage;
            });
            
            setState(prev => ({
                ...prev,
                group_pages: new_group_pages,
                data_api: {
                    ...prev.data_api,
                    fanpages: updated_fanpages
                }
            }));
            
            // Reload data để đảm bảo sync với database
            reloadData();
        }

    useEffect(() => {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookies.is_login
                },
                body: JSON.stringify({
                    // fanpage_id: id,
                    page: state.page,
                    lang: i18n.language
                })
            };            
            fetch(api.get_post, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.success) {
                        setState(prev => ({
                            ...prev,
                            data_api: result.datas,
                            last_page: result.last_page,
                            group_pages: result.group_pages,
                            // loading_page: false,
                            // loading_post: false
                        }))
                    } 
                    // else {
                    //     setState({
                    //         ...state,
                    //         loading_page: false,
                    //         loading_post: false
                    //     })
                    // }
                }
            )
    }, [cookies.is_login, i18n.language, state.page]);
    return (
        <Container maxWidth="xl">
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                {t("post.groupPages")}
            </Typography>
            {/* Dialog 1: Form Phân Nhóm */}
            {/* <Dialog open={state.dialog} fullWidth maxWidth='sm' onClose={() => setState({ ...state, dialog: false })}> */}
                {/* <DialogTitle>{t("post.groupPages")}</DialogTitle> */}
                {/* <DialogContent dividers> */}
                    <Trans i18nKey={"post.groupPagesNotice"} components={{ b: <b style={{ color: 'red' }} /> }} />
                    <p>
                        <Trans i18nKey={"post.totalPages"} components={{ b: <b /> }} values={{ count: props.data_api?.fanpages.length }} />
                    </p>
                    <form onSubmit={handleSubmit(splitFanpage)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField {...register('group_name')} required type="text" fullWidth label={t("post.groupName")} variant="outlined" sx={{ mb: 2 }} />
                            </Grid>
                            <Grid item xs={12}>
                                <Button 
                                    variant="outlined" 
                                    fullWidth 
                                    onClick={() => setState({ ...state, dialogSelectPage: true })}
                                    sx={{ justifyContent: 'space-between', py: 1.5, mb: 1 }}
                                >
                                    <span>{t("post.selectFanpage")}</span>
                                    <b>{state.fanpage_selected.length} Page</b>
                                </Button>
                                <div style={{ fontSize: '12px', color: '#666', mb: 2 }}>
                                    {state.fanpage_selected.slice(0, 5).map(i => i.name).join(', ')}
                                    {state.fanpage_selected.length > 5 && '...'}
                                </div>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <LoadingButton className="text-transform" type="submit" size="large" fullWidth loading={state.loading_submit} variant="contained">
                                    {t("post.confirmGroupPages")}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                {/* </DialogContent>
            </Dialog> */}

            {/* Dialog 2: CHỌN FANPAGE (2 CỘT + CHỌN TẤT CẢ) */}
            <Dialog 
                open={state.dialogSelectPage} 
                fullWidth 
                maxWidth='md' // Tăng kích thước dialog lên md (trung bình lớn)
                onClose={() => setState({ ...state, dialogSelectPage: false })}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {t("Chọn Fanpage")}
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={isAllSelected}
                                indeterminate={state.fanpage_selected.length > 0 && !isAllSelected}
                                onChange={handleSelectAll} 
                            />
                        }
                        label={t("Chọn tất cả")}
                    />
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Tìm theo tên hoặc ID..."
                        value={state.searchTerm}
                        onChange={(e) => setState({ ...state, searchTerm: e.target.value })}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ mb: 2 }}
                    />
                    
                    {/* Sử dụng Grid container để chia 2 cột */}
                    <Grid container spacing={1}>
                        {filteredFanpages.map((fanpage) => {
                            const isChecked = state.fanpage_selected.some(item => item.fanpage_id === fanpage.fanpage_id);
                            return (
                                <Grid item xs={12} sm={6} key={fanpage.fanpage_id}>
                                    <ListItem 
                                        sx={{ 
                                            border: '1px solid #eee', 
                                            borderRadius: '8px',
                                            mb: 1,
                                            '&:hover': { bgcolor: '#f5f5f5' }
                                        }}
                                        button 
                                        onClick={() => handleTogglePage(fanpage)}
                                    >
                                        <Checkbox edge="start" checked={isChecked} disableRipple />
                                        <ListItemAvatar>
                                            <Avatar src={fanpage.avatar} sx={{ width: 32, height: 32 }} />
                                        </ListItemAvatar>
                                        <ListItemText 
                                            primary={fanpage.name} 
                                            secondary={fanpage.fanpage_id} 
                                            primaryTypographyProps={{ noWrap: true, fontSize: '14px' }}
                                        />
                                    </ListItem>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setState({ ...state, dialogSelectPage: false })} variant="contained" fullWidth size="large">
                        Xác nhận đã chọn ({state.fanpage_selected.length})
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Giao diện chính bên ngoài */}
            {/* <Grid item xs={5} container direction={"column"} alignItems="flex-start"> */}
                {/* Nút Phân nhóm Page (Mở Dialog 1) */}
                {/* <Button 
                    className="text-transform" 
                    onClick={() => setState({ ...state, dialog: true })} 
                    variant="text" 
                    color="success"
                >
                    {t("post.groupPages")} 
                </Button> */}

                {/* Nút Danh sách nhóm page */}
                
            {/* </Grid> */}
        </Container>
    )
}